import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

//components
import SelectShotTableRow from "./SelectShotTableRow";

export default class SelectShotTable extends Component {
  constructor(props) {
    super(props);
    let filters = this.props.shots.map(item => item.scene).filter((item, i, array) => array.indexOf(item) === i);
    console.log("filters", filters);
    this.state = {
      selectedRow: null,
      selectedMenu: null,
      selected: [],
      filters,
      orderBy: "scene",
      order: "asc",
      filterstate: ""
    };

    this.handleSelectRow = this.handleSelectRow.bind(this);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
  }

  handleSelectRow(selectedRow) {
    console.log("hello");
    selectedRow === this.state.selectedRow ? this.setState({ selectedRow: null, selectedMenu: null }) : this.setState({ selectedRow });
  }

  handleMenu(e) {
    this.setState({ selectedMenu: e.currentTarget });
  }

  handleCloseMenu() {
    this.setState({ selectedMenu: null });
  }

  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };
  // handleSelectAllClick = event => {
  //   if (event.target.checked) {
  //     const newSelecteds = this.props.shots.filter(e => e.scene.toUpperCase().includes(this.state.filterstate.toUpperCase())).map(n => n.name);
  //     this.setState({
  //       selected: newSelecteds
  //     });
  //     return;
  //   }
  //   this.setState({
  //     selected: []
  //   });
  // };
  handleChangeFilter = e => {
    this.props.handleFilter(e.target.value, "selectedShots", "shots", "scene");
  };

  render() {
    const { orderBy, order } = this.state;
    let { selectedFilter, selectedShots } = this.props;
    let filteredData = this.stableSort(this.props.shots, this.getSorting(order, orderBy)).filter(e =>
      e.scene.toUpperCase().includes(selectedFilter.toUpperCase())
    );
    let dataLists = filteredData.map((item, index) => {
      const open = Boolean(this.state.selectedMenu) && this.state.selectedRow === item.id ? true : false;
      const selectedRow = this.state.selectedRow === item.id ? true : false;
      const menuAnchorEl = this.state.selectedRow === item.id ? this.state.selectedMenu : null;
      return (
        <SelectShotTableRow
          index={index}
          hasCheckbox={this.props.hasCheckbox}
          checked={this.props.selectedShots.includes(item.id)}
          key={item.id}
          {...item}
          type={this.props.type}
          selectedRow={selectedRow}
          handleSelectRow={this.handleSelectRow}
          handleMenu={this.handleMenu}
          handleCloseMenu={this.handleCloseMenu}
          selectedMenu={menuAnchorEl}
          menuSelected={open}
          handleSelectedShot={this.props.handleSelectedShot}
        />
      );
    });
    const headCells = [
      { id: "scene", numeric: false, disablePadding: false, label: "Scene", width: "15%" },
      { id: "description", numeric: false, disablePadding: false, label: "Description", width: this.props.type === "photo" ? "30%" : "15%" },
      { id: "location", numeric: false, disablePadding: false, label: "Location", width: "15%" },
      { id: "angle", numeric: false, disablePadding: false, label: "Angle", width: "15%" },
      { id: "framing", numeric: false, disablePadding: false, label: "Framing", width: "15%" }
    ];

    if (this.props.type == "video") {
      headCells.push({ id: "camera", numeric: false, disablePadding: false, label: "Camera", width: "15%" });
    }
    console.log("sample", this.props.type);
    return (
      <Grid container>
        <Grid item xs={12} sm={12}>
          {this.props.fetching ? (
            <div style={{ textAlign: "center" }}>
              <LinearProgress color="primary" style={{ height: 2 }} />
            </div>
          ) : this.props.failed ? (
            <div>
              <h1>Failed to load. Please try again later.</h1>
              <Button size="small" variant="contained" color="secondary" onClick={this.getShots} style={{ marginLeft: 20 }}>
                Reload
              </Button>
            </div>
          ) : null}
          <Toolbar>
            <Typography variant="subtitle2">Please select the shots that you want to add to the shoot.</Typography>
            <div style={{ flexGrow: 1 }} />
            <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
              Filter Scene:
            </Typography>
            <FormControl variant="outlined" style={{ marginRight: 10 }}>
              <Select
                value={selectedFilter}
                onChange={this.handleChangeFilter}
                displayEmpty={true}
                input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {this.state.filters.map(value => (
                  <MenuItem value={value} key={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Toolbar>
          <Divider />
          <Table style={{ tableLayout: "fixed" }}>
            {/* <TableHead>
                <TableRow>
                  <TableCell style={{ width: '10%'}} padding="checkbox"><Checkbox onClick={this.props.onSelectedAll} checked={this.props.selectedAll} /></TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '15%' : '10%'}}>Scene</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '36%' : '35%'}}>Description</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%'}}>Location</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%'}}>Angle</TableCell>
                  <TableCell style={{ width: this.props.type === "photo" ? '13%' : '10%'}}>Framing</TableCell>
                  {
                    this.props.type === "video" 
                    ?
                    <TableCell style={{ width: '10%'}}>Camera Movement</TableCell>
                    : null
                  }
                </TableRow>
              </TableHead> */}
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" style={{ width: "10%" }}>
                  <Checkbox
                    onClick={() => this.props.onSelectedAll("selectedShots", "shots", "scene")}
                    checked={this.props.selectedAll}
                    indeterminate={selectedShots.length > 0 && selectedShots.length < filteredData.length}
                    checked={filteredData.length > 0 ? selectedShots.length === filteredData.length : false}
                    color="primary"
                  />
                </TableCell>
                {headCells.map((row, key) => (
                  <TableCell
                    key={key}
                    align={row.numeric ? "right" : "left"}
                    padding={row.disablePadding ? "none" : "default"}
                    sortDirection={orderBy === row.id ? order : false}
                    onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                    style={row.id == "" ? { width: row.width } : { cursor: "pointer", width: row.width }}
                  >
                    {this.state.orderBy === row.id ? (
                      <TableSortLabel active={orderBy === row.id} direction={order}>
                        {row.label}
                      </TableSortLabel>
                    ) : (
                      row.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{dataLists}</TableBody>
          </Table>
        </Grid>
      </Grid>
    );
  }
}
